<template>
	
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'Test2',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Test2 | byLex Account'});
	},
	data: () => ({
		
	}),
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	components: {
		//Navbar,
	},
}
</script>